import EcoFaqWithImg from 'eco-design/sections/eco-faq-win-img';

import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

const Weather: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Weather');
    return (
        <div
            className={`${styles.Weather} GtmModuleData-section`}
            id={'stream-ultra-x-Weather'}
            data-section-id={'stream-ultra-x-Weather'}
            data-section-title={t('title')}
        >
            <EcoSectionCommon title={t('title')} />
            <EcoFaqWithImg
                className="section-card-faq"
                theme="black"
                items={[
                    {
                        desc: t('item1_desc'),
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1754039402274/20_1.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1754039402274/20_1.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1754039402050/20_1_M.jpg',
                        title: t('item1_title'),
                    },
                    {
                        desc: t('item2_desc'),
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1754039402525/20_2.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1754039402525/20_2.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1754039403034/20_2_M.jpg',
                        title: t('item2_title'),
                    },
                    {
                        desc: t('item3_desc'),
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1754039402797/20_3.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1754039402797/20_3.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1754039403278/20_3_M.jpg',
                        title: t('item3_title'),
                    },
                ]}
                dataLayerTab={{
                    event: 'uaEvent',
                    event_name: 'product_detail_page',
                    list_name: t('title'),
                }}
            />
        </div>
    );
};

export default Weather;
